import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, withCtx as _withCtx, resolveDirective as _resolveDirective, createElementVNode as _createElementVNode, withDirectives as _withDirectives, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/more.png'


const _withScopeId = n => (_pushScopeId("data-v-52ad5b69"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wrap" }
const _hoisted_2 = { class: "content" }
const _hoisted_3 = {
  key: 0,
  class: "good"
}
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { alt: "" }
const _hoisted_6 = { class: "goodContent" }
const _hoisted_7 = { class: "title" }
const _hoisted_8 = { class: "other" }
const _hoisted_9 = { style: {"display":"flex","align-items":"center"} }
const _hoisted_10 = { class: "price" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"font-size":"0.24rem"} }, "￥", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  style: {"width":"0.32rem"},
  src: _imports_0,
  alt: ""
}, null, -1))

import { NavBar, Search, Tabs, Tab, Empty, Toast } from "vant";
import router from "@/router";
import { ref } from "vue";
import { request } from "@/provide/fetch";
import { useRoute } from "vue-router";

export default /*#__PURE__*/_defineComponent({
  name: 'hotGoods',
  setup(__props) {

const route = useRoute();
const nation = route.query.name;
const tabList = ref([
  {
    name: "含卡套餐",
    value: 0,
    disabled: false,
  },
  // {
  //   name: "充值套餐",
  //   value: 1,
  //   disabled: true,
  // },
]);
const activeTab = ref(0);
const goodList = ref([]);
const handleData = () => {
  const channel =
    window.location.hostname === "www.international-card.com"
      ? "aBrTdjlLMn"
      : "paCDWXhjKM";
  request({
    url: `/product/get-product-list?country_name=${route.query.name || ""}&channel=${channel}`,
    // method: "POST",
  })
    .then((res) => {
      goodList.value = res.data;
    })
    .catch(() => {
      Toast("网络错误，请稍后重试");
    });
};
handleData();

return (_ctx: any,_cache: any) => {
  const _component_lazy_component = _resolveComponent("lazy-component")!
  const _directive_lazy = _resolveDirective("lazy")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(NavBar), {
      title: "热门商品",
      "left-arrow": "",
      onClickLeft: _cache[0] || (_cache[0] = ($event: any) => (_unref(router).go(-1)))
    }),
    _createVNode(_unref(Tabs), {
      active: activeTab.value,
      "onUpdate:active": _cache[1] || (_cache[1] = ($event: any) => ((activeTab).value = $event)),
      color: "#386bf6"
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tabList.value, (item, index) => {
          return (_openBlock(), _createBlock(_unref(Tab), {
            title: item.name,
            key: index,
            disabled: item.disabled
          }, null, 8, ["title", "disabled"]))
        }), 128))
      ]),
      _: 1
    }, 8, ["active"]),
    _createElementVNode("div", _hoisted_2, [
      (goodList.value.length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(goodList.value, (item, index) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "goodItem",
                key: index,
                onClick: ($event: any) => (_unref(router).push(`/hotGoodsDetails/${item.id}`))
              }, [
                _createVNode(_component_lazy_component, null, {
                  default: _withCtx(() => [
                    _withDirectives(_createElementVNode("img", _hoisted_5, null, 512), [
                      [_directive_lazy, item.picUrl]
                    ])
                  ]),
                  _: 2
                }, 1024),
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, _toDisplayString(item.productName), 1),
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("div", _hoisted_9, [
                      _createElementVNode("div", _hoisted_10, [
                        _hoisted_11,
                        _createTextVNode(_toDisplayString(item.productFloorPrice), 1)
                      ])
                    ]),
                    _hoisted_12
                  ])
                ])
              ], 8, _hoisted_4))
            }), 128))
          ]))
        : (_openBlock(), _createBlock(_unref(Empty), {
            key: 1,
            "image-size": "100",
            description: "暂无数据"
          }))
    ])
  ]))
}
}

})